import { formatDateFromUTCtoAgent } from '../agentSms/utils';

// Lead-engagement timestamps render the zone inline (e.g. "Jul 24, 2026, 12:18 PM MDT")
// so a bare time isn't ambiguous when the viewer isn't in the agent's timezone.
export const formatDateWithZone = (
  dateString: string,
  timezone: string,
): string =>
  formatDateFromUTCtoAgent(dateString, timezone, { includeZone: true });
